export const reduceConcat = (acc = [], item, index) => acc.concat(item)

export default reduceConcat
